import { createContext, useContext, useState } from "react";

interface AuditFormContextType {
    refreshAuditForms: boolean;
    setRefreshAuditForms: React.Dispatch<React.SetStateAction<boolean>>;
    refreshAuditRecords: boolean;
    setRefreshAuditRecords: React.Dispatch<React.SetStateAction<boolean>>;
    refreshMedia: boolean;
    setRefreshMedia: React.Dispatch<React.SetStateAction<boolean>>;
    isModalVisible: boolean;
    setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
    calendarModalVisible: boolean;
    setCalendarModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
    isAuditModalVisible: boolean;
    setIsAuditModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
    isTaskModalVisible: boolean;
    setIsTaskModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
    // Add selected group data for modals
    selectedGroupForTask: any;
    setSelectedGroupForTask: React.Dispatch<React.SetStateAction<any>>;
    selectedGroupForAudit: any;
    setSelectedGroupForAudit: React.Dispatch<React.SetStateAction<any>>;
}

const AuditFormContext = createContext<AuditFormContextType | undefined>(undefined);

export const AuditFormProvider = ({ children }: { children: React.ReactNode }) => {
    const [refreshAuditForms, setRefreshAuditForms] = useState(false);
    const [refreshAuditRecords, setRefreshAuditRecords] = useState(false);
    const [refreshMedia, setRefreshMedia] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [calendarModalVisible, setCalendarModalVisible] = useState(false);
    const [isAuditModalVisible, setIsAuditModalVisible] = useState(false);
    const [isTaskModalVisible, setIsTaskModalVisible] = useState(false);
    // Add state for selected groups
    const [selectedGroupForTask, setSelectedGroupForTask] = useState(null);
    const [selectedGroupForAudit, setSelectedGroupForAudit] = useState(null);

    const contextValue: AuditFormContextType = {
        refreshAuditForms,
        setRefreshAuditForms,
        refreshAuditRecords,
        setRefreshAuditRecords,
        refreshMedia,
        setRefreshMedia,
        isModalVisible,
        setIsModalVisible,
        calendarModalVisible,
        setCalendarModalVisible,
        isAuditModalVisible,
        setIsAuditModalVisible,
        isTaskModalVisible,
        setIsTaskModalVisible,
        selectedGroupForTask,
        setSelectedGroupForTask,
        selectedGroupForAudit,
        setSelectedGroupForAudit,
    };

    return (
        <AuditFormContext.Provider value={contextValue}>
            {children}
        </AuditFormContext.Provider>
    );
};

export const useModalVisibilityContext = () => {
    const context = useContext(AuditFormContext);
    if (context === undefined) {
        throw new Error(
            "useModalVisibilityContext must be used within a AuditFormProvider"
        );
    }
    return context;
};
